<template>
  <v-text-field
    v-bind="[fieldProps, $attrs]"
    name="referencia"
    placeholder="Referência"
    clearable
  ></v-text-field>
</template>

<script>
import { mixin } from "./mixin";

export default {
  mixins: [mixin],
};
</script>
